import React, { useState, useRef, useEffect } from "react";
import styles from "./TeachingListview.module.css";
import "./Profile.css";
import "./FacultyDatePicker.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import moment from "moment";
import { AxiosInstance } from "../../../../axios";
import { R_PER_PAGE } from "../../../../labels";
import { styled } from "@mui/material/styles";
import Loader from "../../Loader";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import DatePickerSample from "../../DatePicker";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";

function PanelMembersLiistview(props) {
  const menuList = JSON.parse(sessionStorage.getItem("menu_list")) || [];
  const userJSON = sessionStorage.getItem("userDetails");
  let userType = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userType = user?.user_type;
    }
  } else {
    console.log("User Id cannot available in session storage");
  }
  const moment = require("moment-timezone");
  const locationS = useLocation();
  const { filDep, filStatus, filSearch, filDesign, fillAon, filFrom } =
    locationS.state ? locationS.state : {};
  const txtBSearch = useRef(null); //Search icon
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);
  const filterAppliedRef = useRef(null);
  const filterStatusRef = useRef(null);
  const filterDesignRef = useRef(null);
  const filterDepartRef = useRef(null);
  // use state
  let page = R_PER_PAGE;
  // use state
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState("asc");
  const [updateListData, setUpdateListData] = useState([]);
  const [csvListData, setCsvListData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [isOpen, setIsOpen] = useState({
    status: false,
    location: false,
    category: false,
    designation: false,
    department: false,
    appliedOn: false,
  });

  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [designationOptions, setDesignationOptions] = useState([]);
  const [updateChipData, setUpdateChipData] = useState([]);
  const [typeOn, setTypeOn] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchDep, setSearchDep] = useState("");
  const [dept, setDept] = useState([]);
  const [status, setStatus] = useState([]);
  const [appOn, setAppOn] = useState([]);
  const [appData, setAppData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });

  let filterStatus = [];
  let filterSearch = [];
  let filterType = [];
  let filterDept = [];
  let filterApplyed = [];

  useEffect(() => {
    filterStatus = status;
  }, [status]);
  useEffect(() => {
    filterType = typeOn;
  }, [typeOn]);
  useEffect(() => {
    filterDept = dept;
  }, [dept]);
  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);
  useEffect(() => {
    if (locationS.state) {
    }
  }, [locationS.state]);

  useEffect(() => {
    if (locationS.state) {
      const timer = setTimeout(() => {
        navigate(locationS.pathname, { replace: true, state: null });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [locationS.pathname]);

  useEffect(() => {
    setUpdateChipData([
      { id: props.activeTab, name: "ActiveTab", type: "ActiveTab" },
    ]);
  }, [props.activeTab]);

  useEffect(() => {
    if (props.activeTab === 3 && updateChipData.length > 0) {
      loadListdata();
    }
  }, [updateChipData]);

  useEffect(() => {
    if (props.tabChanged) {
      handleAllClear();
      props.setTabChanged(false);
    }
  }, [props.tabChanged]);

  useEffect(() => {
    if (props.activeTab === 3) {
      if (filStatus && filStatus.length > 0 && filFrom === 3) {
        setStatus(filStatus);
        filterStatus = filStatus;
      } else {
        setStatus(status);
        filterStatus = status;
      }
      if (fillAon && fillAon.length > 0 && filFrom === 3) {
        const filterDates = fillAon[0];
        setAppData({
          FDate: filterDates.fdate,
          TDate: filterDates.edate,
          Days: filterDates.Days,
          name: "",
        });
        setAppOn(fillAon);
        filterApplyed = fillAon;
      }
      // if (fillAon && fillAon.length > 0) {
      //   setAppOn(fillAon);
      //   filterApplyed = fillAon;
      // } else {
      //   setAppOn(appOn);
      //   filterApplyed = appOn;
      // }
      if (filDep && filDep.length > 0 && filFrom === 3) {
        setDept(filDep);
        filterDept = filDep;
      } else {
        setDept(dept);
        filterDept = dept;
      }
      if (filDesign && filDesign.length > 0 && filFrom === 3) {
        setTypeOn(filDesign);
        filterType = filDesign;
      } else {
        setTypeOn(typeOn);
        filterType = typeOn;
      }
      if (filSearch && filSearch.length > 0 && filFrom === 3) {
        filterSearch = [{ name: "" + filSearch, type: "search" }];
        setSearchTerm(filSearch);
      } else {
        if (searchTerm) {
          setSearchTerm(searchTerm);
          filterSearch = [{ name: "" + searchTerm, type: "search" }];
        }
      }
      loadChipdata();
    }
  }, [props.activeTab]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterDesignRef.current &&
        !filterDesignRef.current.contains(event.target)
      ) {
        const hasCategory = updateChipData.some(
          (chipItem) => chipItem.type === "type"
        );
        if (hasCategory) {
          const updatedSection = updateChipData.filter(
            (chipItem) => chipItem.type === "type"
          );
          setTypeOn(updatedSection);
        } else {
          setTypeOn([]);
        }
        setIsOpen((prev) => ({ ...prev, designation: false }));
      }

      if (
        filterDepartRef.current &&
        !filterDepartRef.current.contains(event.target)
      ) {
        const hasCategory = updateChipData.some(
          (chipItem) => chipItem.type === "department"
        );
        if (hasCategory) {
          const updatedSection = updateChipData.filter(
            (chipItem) => chipItem.type === "department"
          );
          setDept(updatedSection);
        } else {
          setDept([]);
        }
        setIsOpen((prev) => ({ ...prev, department: false }));
      }

      if (
        filterStatusRef.current &&
        !filterStatusRef.current.contains(event.target)
      ) {
        const hasStatus = updateChipData.some(
          (chipItem) => chipItem.type === "status"
        );
        if (hasStatus) {
          const updatedStatus = updateChipData.filter(
            (chipItem) => chipItem.type === "status"
          );
          setStatus(updatedStatus);
        } else {
          setStatus([]);
        }
        setIsOpen((prev) => ({ ...prev, status: false }));
      }

      // APPLIED ON FILTER
      if (
        filterAppliedRef.current &&
        !filterAppliedRef.current.contains(event.target)
      ) {
        const mismatchedDay = updateChipData.find(
          (chipItem) => chipItem.Days && chipItem.Days === appData.Days
        );

        if (mismatchedDay) {
          setAppData({
            FDate: "",
            TDate: "",
            Days: mismatchedDay.Days,
          });
          setAppOn([
            {
              FDate: "",
              TDate: "",
              Days: mismatchedDay.Days,
            },
          ]);
        } else {
          const mismatchedDate = updateChipData.find(
            (chipItem) =>
              chipItem.fdate === appData.FDate &&
              chipItem.edate === appData.TDate
          );

          if (mismatchedDate) {
            setAppData({
              FDate: mismatchedDate.fdate,
              TDate: mismatchedDate.edate,
              Days: "",
            });
            setAppOn([
              {
                FDate: mismatchedDate.fdate,
                TDate: mismatchedDate.edate,
                Days: "",
              },
            ]);
          } else {
            setAppData({
              FDate: "",
              TDate: "",
              Days: "",
            });
            setAppOn([]);
          }
        }

        setIsOpen((prev) => ({ ...prev, appliedOn: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData]);
  function updateStateData() {
    filterStatus = status;
    filterType = typeOn;
    filterDept = dept;
    filterApplyed = appOn;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  //sorting function

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
  };

  // filter checkbox update

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (
      name === "Active" ||
      name === "InActive" ||
      name === "WaitingForApproval" ||
      name === "InviteSent"
    ) {
      if (checked) {
        // setStatus([...status, value]);
        setStatus([...status, { id: value, name: name, type: "status" }]);
      } else {
        setStatus(status.filter((item) => item.id !== value));
      }
    } else if (typename === "type") {
      if (checked) {
        setTypeOn([{ id: value, name: name, type: "type" }]);
      } else {
        setTypeOn(typeOn.filter((item) => item.value !== value));
      }
    } else if (typename === "dept") {
      if (checked) {
        setDept((prev) => [{ id: value, name: name, type: "dept" }]);
      } else {
        setDept((prev) => prev.filter((item) => item.id !== value));
      }
    }
  };

  // handle search function
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      // 👇 Get input value
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };
  //----search icon function
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        code: "Enter",
        which: 13,
        keyCode: 13,
        bubbles: true,
      });
      txtBSearch.current.dispatchEvent(event);
    }
  };
  //----end---
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  //chips overall clear button
  const handleAllClear = () => {
    setSearchTerm("");
    setStatus([]);
    setTypeOn([]);
    setDept([]);
    setAppOn([]);
    setAppData({
      FDate: "",
      TDate: "",
      Days: "",
      name: "",
    });
    setUpdateChipData([
      { id: props.activeTab, name: "ActiveTab", type: "ActiveTab" },
    ]);
  };

  // filter apply button

  const handleApplyFilter = (name) => {
    updateStateData();
    if (name === "status") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "appliedOn") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        appliedOn: false,
      });
    } else if (name === "type") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        designation: false,
      });
    } else if (name === "department") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        department: false,
      });
    }
  };

  function loadListdata() {
    let tempstatus = [];
    let temptypeon = [];
    let tempdept = [];

    status.map((obj) => {
      if (obj.id === "2") {
        tempstatus.push("3", obj.id);
      } else {
        tempstatus.push(obj.id);
      }
    });
    typeOn.map((obj) => {
      temptypeon.push(obj.id);
    });

    dept.map((obj) => {
      tempdept.push(obj.id);
    });

    let statusFilter = {
      category: "",
      subject: "",
      designation: "",
      department: "",
      status: status.length > 0 ? tempstatus : "",
      staff_type: 3,
      search: searchTerm.length > 0 ? searchTerm : "",
      designation_id: typeOn.length > 0 ? temptypeon : "",
      department_id: dept.length > 0 ? tempdept : "",
      start_date: appOn.length > 0 ? appOn[0].fdate : "",
      end_date: appOn.length > 0 ? appOn[0].edate : "",
    };
    setIsLoading(true);
    AxiosInstance.post("api/staff/list", statusFilter)
      .then((res) => {
        if (res.data.status === true) {
          setCurrentPage(1);
          setIsLoading(false);
          const updatedData = res.data.data.map((item) => {
            if (item.staff_type === 3) {
              // set staff type to 1 here if you want to update it
              return item;
            } else {
              return null;
            }
          });
          // filter out null items
          const filteredData = updatedData.filter((item) => item !== null);

          // set the state with the filtered data
          const serialNumberAddedData = filteredData.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          // setUpdateListData(fiata);
          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            fullname: item.fullname,
            mobile_no: item.mobile_no,
            email: item.email,
            department: item.department,
            exp_designation: item.exp_designation,
            created_dt: moment(item.created_dt).isValid()
              ? moment(item.created_dt).format("DD/MM/YYYY")
              : "-",
            status: item.status === 3 ? "InActive" : "Active",
          }));
          setCsvData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);

          const uniqueDepartment = [];
          const seen = new Set();

          serialNumberAddedData?.forEach((item) => {
            const dep = item;
            const departmentValue = dep?.department?.trim();

            if (departmentValue && !seen.has(departmentValue)) {
              seen.add(departmentValue);
              uniqueDepartment.push(dep);
            }
          });

          const options = uniqueDepartment.map((dep, index) => ({
            label: dep?.department,
            value: dep?.department_id,
          }));

          setDepartmentOptions(options);

          const uniqueDesignation = [];
          const designationSeen = new Set();

          serialNumberAddedData?.forEach((item) => {
            const des = item;
            const designationValue = des?.exp_designation?.trim();

            if (designationValue && !designationSeen.has(designationValue)) {
              designationSeen.add(designationValue);
              uniqueDesignation.push(des);
            }
          });

          const desigOptions = uniqueDesignation.map((des, index) => ({
            label: des?.exp_designation,
            value: des?.designation_id,
          }));

          setDesignationOptions(desigOptions);

          const csvData = filteredData.map((el) => {
            return {
              fullname: el.fullname,
              faculty_id: el.faculty_id,
              mobile_no: el.mobile_no,
              email: el.email,
              department: el.department,
              exp_designation: el.exp_designation,
            };
          });
          setCsvListData(csvData);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setUpdateListData([]);
        return error;
      });
  }

  function loadChipdata() {
    //setUpdateChipData([]);
    let tempArr = [];

    filterApplyed.map((obj) => {
      tempArr.push(obj);
    });
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });

    filterType.map((obj) => {
      tempArr.push(obj);
    });

    filterDept.map((obj) => {
      tempArr.push(obj);
    });

    if (tempArr?.length > 0) {
      setUpdateChipData(tempArr);
    } else {
      setUpdateChipData([
        { id: props.activeTab, name: "ActiveTab", type: "ActiveTab" },
      ]);
    }
  }

  // filter clear button
  const handleClear = (name) => {
    updateStateData();
    if (name === "status") {
      // Clear the status array
      setStatus([]);
      filterStatus = [];
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "appliedOn") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
      setIsOpen({
        ...isOpen,
        appliedOn: false,
      });
    } else if (name === "type") {
      setTypeOn([]);
      filterType = [];

      setIsOpen({
        ...isOpen,
        designation: false,
      });
    } else if (name === "department") {
      setDept([]);
      filterDept = [];

      setIsOpen({
        ...isOpen,
        department: false,
      });
    }
    loadChipdata();
  };

  // //   checking once again  -  handle delete function
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (
      chipToDelete.type === "dayRange" ||
      chipToDelete.type === "dateRange"
    ) {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
    } else if (chipToDelete.type === "status") {
      setStatus(status.filter((item) => item.id !== chipToDelete.id));
      filterStatus = status.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "type") {
      setTypeOn(typeOn.filter((item) => item.name !== chipToDelete.name));
      filterType = typeOn.filter((item) => item.name !== chipToDelete.name);
    } else if (chipToDelete.type === "dept") {
      setDept(dept.filter((item) => item.name !== chipToDelete.name));
      filterDept = dept.filter((item) => item.name !== chipToDelete.name);
    } else {
      // filterApplyed = [];
    }
    loadChipdata();
  };

  const handleFilter = (e, boxName) => {
    if (boxName === "status") {
      setIsOpen((prevState) => ({
        location: false,
        category: false,
        designation: false,
        department: false,
        status: !prevState.status,
      }));
    } else if (boxName === "appliedOn") {
      setIsOpen((prevState) => ({
        location: false,
        category: false,
        designation: false,
        department: false,
        status: false,
        appliedOn: !prevState.appliedOn,
      }));
    } else if (boxName === "designation") {
      setIsOpen((prevState) => ({
        location: false,
        category: false,
        department: false,
        status: false,
        designation: !prevState.designation,
      }));
    } else if (boxName === "department") {
      setIsOpen((prevState) => ({
        location: false,
        category: false,
        status: false,
        designation: false,
        department: !prevState.department,
      }));
    }
  };

  // generate pdf when user click download button
  const generatePDF = () => {
    const headers = [
      "S.No",
      "Panel Member Name",
      "Phone Number",
      "Email ID",
      "Department",
      "Designation",
      "Joined On",
      "Status",
    ];

    const rows = csvData.map((item, index) => [
      index + 1,
      item.fullname ?? "-",
      item.mobile_no ?? "-",
      item.email ?? "-",
      item.department ?? "-",
      item.exp_designation ?? "-",
      moment(item.created_dt).isValid()
        ? moment(item.created_dt).format("DD/MM/YYYY")
        : "-",
      item.status === 3 ? "InActive" : "Active",
    ]);
    navigate("/preview", {
      state: {
        title: "Panel Members Data",
        headers,
        rows,
        filename: "PanelMembersData.pdf",
        autoPrint: true,
      },
    });
  };
  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");

    if (name === "FDate" || name === "TDate") {
      // First, update the date fields and reset Days
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "", // Reset Days when FDate or TDate is set
        };

        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;

        // Only set AppOn if both from and to dates are available
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };

  const handleAppliedOn = (e) => {
    const { name, value, checked } = e.target;

    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: value,
          Days: "", // Reset Days when FDate or TDate is changed
        };

        const from = name === "FDate" ? value : updated.FDate;
        const to = name === "TDate" ? value : updated.TDate;

        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        } else {
          setAppOn([
            {
              name: "",
              fdate: "",
              edate: "",
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    } else if (name === "Days") {
      if (checked) {
        // Set Days and reset FDate/TDate
        setAppData({
          FDate: "",
          TDate: "",
          Days: value,
        });

        const today = new Date();
        let fdate = "";
        let edate = "";
        let label = "";

        if (value === "Today") {
          fdate = edate = moment(today).format("YYYY-MM-DD");
          label = "Today";
        } else if (value === "Yesterday") {
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          fdate = edate = moment(yesterday).format("YYYY-MM-DD");
          label = "Yesterday";
        } else if (value === "Tweek") {
          const start = moment(today).startOf("week").toDate();
          const end = moment(today).endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This week";
        } else if (value === "Lweek") {
          const start = moment(today)
            .subtract(1, "week")
            .startOf("week")
            .toDate();
          const end = moment(today).subtract(1, "week").endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last week";
        } else if (value === "Tmonth") {
          const start = new Date(today.getFullYear(), today.getMonth(), 1);
          const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This month";
        } else if (value === "Lmonth") {
          const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const end = new Date(today.getFullYear(), today.getMonth(), 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last month";
        }

        setAppOn([
          {
            name: label,
            fdate,
            edate,
            type: "dayRange",
            Days: value,
          },
        ]);
      }
    }
  };

  // total table data  with pages
  const totalPages = Math.ceil(updateListData.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };
  // page count handle
  const handlePageCount = (e) => {
    const { name, value, checked } = e.target;

    setRowsPerPage(parseInt(value));
    setCurrentPage(1);
    setUpdateListData([]);

    if (props.activeTab === 3) {
      loadListdata();
    }
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData.slice(start, end);

  const handleReadView = (userId) => {
    navigate(`/ReviewFacultyProfile/${userId}`, {
      state: {
        DEP: dept,
        DESIGNATION: typeOn,
        SEARCHTERM: searchTerm,
        STATUS: status,
        FAPON: appOn,
        FROM: 3,
      },
    });
  };
  const handleDetailView = (userId, staff_id) => {
    navigate(`/Faculties/PanelMember/${userId}/${staff_id}`, {
      state: {
        STAFFTYPE: 3,
        DEP: dept,
        DESIGNATION: typeOn,
        SEARCHTERM: searchTerm,
        STATUS: status,
        FAPON: appOn,
        FROM: 3,
      },
    });
  };

  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Panel Member Name", key: "fullname" },
    { label: "Phone Number", key: "mobile_no" },
    { label: "Email", key: "email" },
    { label: "Department", key: "department" },
    { label: "Designation", key: "exp_designation" },
    { label: "Joined On", key: "created_dt" },
    { label: "Status", key: "status" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      <div
        className={`${styles.CourseInfoSec} ${styles.cm_ListViewForm} container-fluid  global_container p-0`}
      >
        {/* ---------------------------------------------------------------- */}
        <div className="row ">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div class="input-group ">
              <input
                ref={txtBSearch}
                type="text"
                class={styles.Inputs}
                id="SearchInput"
                name="SearchInput"
                placeholder="Search by Name and Phone number"
                onKeyDown={handleSearch}
              />
              <span
                class={styles.input_group_text}
                id="SearchInput"
                onClick={handleSearchFocus}
              >
                <span className="material-icons" onClick={handleSearchFocus}>
                  search
                </span>
              </span>
            </div>
          </div>

          <div className="col-md-8 col-12 ListBtn">
            <ul class="List-Button">
              {((Array.isArray(menuList) && menuList.includes(127)) ||
                userType === 1) && (
                <>
                  <li class="ListBtnItems">
                    <CustomDownloadButton
                      csvListData={csvData?.length > 0 ? csvData : ""}
                      headers={csvHeaders}
                      iconName=" file_download "
                      filename={"PanelMember.csv"}
                      csvName="Download as CSV"
                    />
                  </li>
                  <li className="ListBtnItems">
                    <Link
                      to="javascript:void(0)"
                      className="primaryButton "
                      variant="primary"
                      onClick={generatePDF}
                    >
                      <span className="material-icons me-2 fs-4 align-middle text-white">
                        file_download
                      </span>
                      <span className="text-white">Download as PDF</span>
                    </Link>
                  </li>
                </>
              )}

              <li class="ListBtnItems">
                <Link
                  to="/Faculties/AddPanelMember"
                  className="primaryButton "
                  variant="primary"
                >
                  Add New Panel Member
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {updateChipData.filter((kl) => kl.name !== "ActiveTab")?.length > 0 ? (
          <div className="row mt-3">
            <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                {updateChipData
                  .filter((kl) => kl.name !== "ActiveTab")
                  .map((data, index) => {
                    let icon;
                    let key = "" + data.name;
                    return (
                      <>
                        <div style={{ marginRight: "10px" }}>
                          <Chip
                            icon={icon}
                            label={
                              <>
                                <span className={styles.BoldTyText}>{key}</span>
                              </>
                            }
                            onDelete={handleDelete(data, index)}
                          />
                        </div>
                      </>
                    );
                  })}

                {/* Show Clear All Filters once at the end */}
                <a
                  className={styles.allclear}
                  href="javascript:void(0)"
                  onClick={handleAllClear}
                >
                  Clear All Filters
                </a>
              </Paper>
            </div>
          </div>
        ) : (
          <div></div>
        )}

        <div className="row mt-2">
          <div className="col-md-12 table-responsive tableMinHeight ">
            <table className="table" id="tableListHeader">
              <thead>
                <tr>
                  {/* S.No. */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      S.No
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      import_export
                    </span>
                  </th>
                  {/* Name */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "fullname")}
                    >
                      Panel Member Name
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "fullname")}
                    >
                      import_export
                    </span>
                  </th>

                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "mobile_no")}
                    >
                      PhoneNumber
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "mobile_no")}
                    >
                      import_export
                    </span>
                  </th>

                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "email")}
                    >
                      Email ID
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "email")}
                    >
                      import_export
                    </span>
                  </th>

                  {/* DEPARTMENT */}
                  <th id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "department")}
                    >
                      Department
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "department")}
                    >
                      import_export
                    </span>{" "}
                  </th>

                  {/* Designation */}
                  <th id="th">
                    <span
                      className="textHead_th px-1"
                      onClick={(e) => handleSort(e, "exp_designation")}
                    >
                      Designation
                    </span>
                    <span
                      className="material-icons textHead_th align-middle"
                      onClick={(e) => handleSort(e, "exp_designation")}
                    >
                      import_export
                    </span>
                    {/* <span
                      className={`textHead_th align-middle material-icons ${
                        typeOn.length > 0 || isOpen.designation
                          ? styles.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "designation")}
                    >
                      filter_list
                    </span> */}

                    {isOpen.designation && (
                      <>
                        <div
                          className="filterBoxs_testlist"
                          style={{ top: "35px" }}
                        >
                          <div className="col-md-12 form-check filterStatus_list">
                            <div className="row mt-2">
                              <div className="col-md-12 mb-2 px-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search designation"
                                  value={searchText}
                                  onChange={(e) =>
                                    setSearchText(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                            <ul className="ulFilterListData">
                              {designationOptions
                                .filter((loc) =>
                                  loc.label
                                    .toLowerCase()
                                    .includes(searchText.toLowerCase())
                                )
                                .map((loc, index) => (
                                  <li className="filterListData" key={loc.id}>
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={loc.label}
                                      value={loc.value}
                                      id={`designation-${index}`}
                                      checked={typeOn.some(
                                        (item) => item.id === String(loc.value)
                                      )}
                                      onChange={(e) =>
                                        handleCheckboxChange(e, "type", "type")
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG"
                                      htmlFor={`designation-${index}`}
                                    >
                                      {loc.label}
                                    </label>
                                  </li>
                                ))}
                            </ul>
                          </div>

                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleClear("type")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleApplyFilter("type")}
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>

                  {/* JOINED DATE */}
                  <th id="th">
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "created_dt")}
                    >
                      Joined On
                    </span>
                    <span
                      class="material-icons align-middle"
                      onClick={(e) => handleSort(e, "created_dt")}
                    >
                      import_export
                    </span>
                    <span
                      onClick={(e) => handleFilter(e, "appliedOn")}
                      class={` align-middle material-icons ${
                        (appData &&
                          Object.entries(appData).some(
                            ([key, val]) =>
                              key !== "name" &&
                              val !== null &&
                              val !== undefined &&
                              val.toString().trim() !== ""
                          )) ||
                        isOpen.appliedOn
                          ? styles.active_icons
                          : ""
                      }`}
                    >
                      filter_list
                    </span>
                    {isOpen.appliedOn === true && (
                      <div
                        className="filterBoxs_testlist container p-1"
                        ref={filterAppliedRef}
                      >
                        <div
                          className=" BathDet "
                          style={{ padding: 0, marginTop: 0, marginBottom: 0 }}
                        >
                          <div className="row mt-1">
                            <div className="col-md-12">
                              <div class="form-check p-1">
                                <label
                                  htmlFor="FDate"
                                  className="d-flex form-label"
                                  style={{
                                    textAlign: "left",
                                    fontSize: "var(--fontSizeFourteen)",
                                    fontWeight: "var(--boldtextWeight)",
                                    fontFamily: "var(--fontfamily2)",
                                    letterSpacing: "0.28px",
                                    color: "var(--colorBlue)",
                                    opacity: 1,
                                  }}
                                >
                                  From Date
                                  <span
                                    data-required="true"
                                    aria-hidden="true"
                                  ></span>
                                </label>

                                <DatePickerSample
                                  IconInput={"filterIocnBoxInput"}
                                  class={"FilterInputs"}
                                  name={"FDate"}
                                  handleChange={handleChangeDate}
                                  fieldInput={appData.FDate}
                                  txtAdMDob={fDatePickerRef}
                                  // maxDate={new Date()}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row mt-1">
                            <div className="col-md-12">
                              <div class="form-check p-1">
                                <label
                                  htmlFor="TDate "
                                  className="d-flex form-label"
                                  style={{
                                    textAlign: "left",
                                    fontSize: "var(--fontSizeFourteen)",
                                    fontWeight: "var(--boldtextWeight)",
                                    fontFamily: "var(--fontfamily2)",
                                    letterSpacing: "0.28px",
                                    color: "var(--colorBlue)",
                                    opacity: 1,
                                  }}
                                >
                                  To Date
                                  <span
                                    data-required="true"
                                    aria-hidden="true"
                                  ></span>
                                </label>
                                <DatePickerSample
                                  class={"FilterInputs"}
                                  IconInput={"filterIocnBoxInput"}
                                  name={"TDate"}
                                  handleChange={handleChangeDate}
                                  fieldInput={appData.TDate}
                                  txtAdMDob={tDatePickerRef}
                                  minDate={appData.FDate}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <div className="row mt-2 mb-2">
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                id="Today"
                                value="Today"
                                checked={appData.Days === "Today"}
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Today"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                Today
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                id="Yesterday"
                                value="Yesterday"
                                checked={appData.Days === "Yesterday"}
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Yesterday"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                Yesterday
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                value="Tweek"
                                checked={appData.Days === "Tweek"}
                                id="Tweek"
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Tweek"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                This week
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                value="Lweek"
                                checked={appData.Days === "Lweek"}
                                id="Lweek"
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Lweek"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                Last week
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                value="Tmonth"
                                checked={appData.Days === "Tmonth"}
                                id="Tmonth"
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Tmonth"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                This month
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div className="form-check d-flex align-items-center">
                              <input
                                className="form-check-input me-2"
                                type="radio"
                                name="Days"
                                checked={appData.Days === "Lmonth"}
                                value="Lmonth"
                                id="Lmonth"
                                onChange={handleAppliedOn}
                              />
                              <label
                                className="form-check-label filterChipText_withoutBG"
                                htmlFor="Lmonth"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: 0,
                                  padding: 0,
                                  marginLeft: 0,
                                }}
                              >
                                Last month
                              </label>
                            </div>
                          </div>
                        </div> */}
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                onClick={() => handleClear("appliedOn")}
                                className="secondaryButton ms-2"
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                onClick={() => handleApplyFilter("appliedOn")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </th>

                  {/* STATUS */}
                  <th id="th" ref={filterStatusRef}>
                    <span
                      className="textHead_th px-1"
                      onClick={(e) => handleSort(e, "status")}
                    >
                      Status
                    </span>
                    <span
                      className="material-icons textHead_th align-middle"
                      onClick={(e) => handleSort(e, "status")}
                    >
                      import_export
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        status.length > 0 || isOpen.status
                          ? styles.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "status")}
                    >
                      filter_list
                    </span>

                    {isOpen.status && (
                      <>
                        <div
                          className="filterBoxs_testlist"
                          style={{ top: "35px", minWidth: "240px" }}
                        >
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="InActive"
                                  value="2"
                                  id="InActive"
                                  checked={status.some((element) => {
                                    if (element.id === "2") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "InActive")
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText bg-danger"
                                  for="defaultCheck1"
                                  htmlFor="InActive"
                                >
                                  InActive
                                </label>
                              </li>

                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="Active"
                                  value="4"
                                  id="Active"
                                  checked={status.some((element) => {
                                    if (element.id === "4") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "Active")
                                  }
                                />
                                <label
                                  className="form-check-label filterChipText bg-green"
                                  for="defaultCheck1"
                                  htmlFor="Active"
                                >
                                  Active
                                </label>
                              </li>
                            </ul>
                          </div>
                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleClear("status")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleApplyFilter("status")}
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>

                  <th id="th">
                    <span className="textHead_th">Action</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentData?.length === 0 ? (
                  <tr>
                    <td
                      colSpan="15"
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentData?.map((course, index) => (
                    <tr key={index}>
                      <td id="td">{course.serialNumber}</td>

                      <td id={`${styles.td}tabTh`}>
                        <span
                          className={`${styles.ellipsis}`}
                          title={course.fullname}
                        >
                          {course.fullname}
                        </span>
                      </td>

                      <td id="td"> {course.mobile_no}</td>
                      <td id="td">{course.email}</td>
                      <td id={`${styles.td}tabTh`}>
                        <span
                          className={`${styles.ellipsis}`}
                          title={course.department}
                        >
                          {course.department || "-"}
                        </span>
                      </td>

                      <td id={`${styles.td}tabTh`}>
                        <span
                          className={`${styles.ellipsis}`}
                          title={course.exp_designation}
                        >
                          {course.exp_designation || "-"}
                        </span>
                      </td>

                      <td id="td">
                        {moment(course.created_dt).format("DD/MM/YYYY")}
                      </td>

                      {course.status === 0 && (
                        <td id="td">
                          <span class="filterChipText bg-orange mx-0">
                            Invite Sent
                          </span>
                        </td>
                      )}
                      {course.status === 1 && (
                        <td id="td">
                          <span class="filterChipText bg-orange mx-0">
                            Waiting For Approval
                          </span>
                        </td>
                      )}
                      {course.status === 5 && (
                        <td id="td">
                          <span class="filterChipText bg-orange mx-0">
                            Cancel Invite
                          </span>
                        </td>
                      )}
                      {course.status === 4 && (
                        <td id="td">
                          <span class="filterChipText bg-green mx-0 ">
                            Active
                          </span>
                        </td>
                      )}
                      {(course.status === 2 || course.status === 3) && (
                        <td id="td">
                          <span class="filterChipText bg-danger mx-0 ">
                            Inactive
                          </span>
                        </td>
                      )}
                      {course.status === 4 && (
                        <td id="td">
                          <button
                            className={"view_icon_button"}
                            onClick={() =>
                              handleDetailView(course.user_id, course.staff_id)
                            }
                          >
                            <span class="material-icons">visibility</span>
                          </button>
                        </td>
                      )}
                      {course.status != 4 && course.status != 1 && (
                        <td id="td">
                          <button
                            onClick={() =>
                              handleDetailView(course.user_id, course.staff_id)
                            }
                            className={"view_icon_button"}
                          >
                            <span class="material-icons">visibility</span>
                          </button>
                        </td>
                      )}
                      {course.status === 1 && (
                        <td id="td">
                          <button
                            className={"view_icon_button"}
                            onClick={() => handleReadView(course.user_id)}
                          >
                            <span class="material-icons"> visibility</span>
                          </button>
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="CourseInfoSec row mt-3">
          <Pagination
            rowsPerPage={rowsPerPage}
            handlePageCount={handlePageCount}
            startPage={
              updateListData?.length > 0
                ? currentPage * rowsPerPage + 1 - rowsPerPage
                : 0
            }
            endPage={
              updateListData?.length > 0
                ? updateListData?.length < currentPage * rowsPerPage
                  ? updateListData?.length
                  : currentPage * rowsPerPage
                : 0
            }
            totalRecords={updateListData?.length || 0}
            handlePrev={() => handlePrev(currentPage - 1)}
            currentPrevPage={currentPage === 1 || totalPages === 0}
            prevButton="prev_buttonViewEvaluator materialIconsRightAndLeft me-2"
            handleNext={() => handleNext(currentPage + 1)}
            currentNextPage={currentPage === totalPages || totalPages === 0}
          />
        </div>
      </div>
    </>
  );
}

export default PanelMembersLiistview;
